import React from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const Form1 = () => {
  const schema = yup.object().shape({
    fullName: yup.string().required("Your Full Name is Required!"),
    email: yup.string().email().required(),
    age: yup.number().positive().integer().min(18).required(),
    password: yup.string().min(4).max(20).required(),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords Don't Match")
      .required(),

    // phNumbers: yup.array().of(
    //     object({
    //         number: yup.number().required("!required").min(10)
    //     })
    // )
    phNumbers: yup.array().of(
      yup.object().shape({
        number: yup
          .number()
          .required("!required")
          .min(10, "invalid contact Number"),
      })
    ),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      fullName: "",
      email: "",
      age: "",
      password: "",
      confirmPassword: "",
      phNumbers: [
        {
          number: "",
        },
      ],
    },
  });

  const { fields, append, remove } = useFieldArray({
    name: "phNumbers",
    control,
  });

  const onSubmit = (data) => {
    console.log(data);
  };

  return (
    <>
      <div className="container m-auto">
        <form onSubmit={handleSubmit(onSubmit)}>
          <input
            type="text"
            placeholder="Full Name..."
            {...register("fullName")}
          />
          <p className="error">{errors.fullName?.message}</p>
          <input type="text" placeholder="Email..." {...register("email")} />
          <p className="error">{errors.email?.message}</p>
          <input type="number" placeholder="Age..." {...register("age")} />
          <p className="error">{errors.age?.message}</p>
          <input
            type="password"
            placeholder="Password..."
            {...register("password")}
          />
          <p className="error">{errors.password?.message}</p>
          <input
            type="password"
            placeholder="Confirm Password..."
            {...register("confirmPassword")}
          />
          <p className="error">{errors.confirmPassword?.message}</p>

          <div>
            <label htmlFor="">List of PhoneNumbers</label>
            {fields.map((field, index) => {
              return (
                <>
                  <div className="form-control" key={field.id}>
                    <input
                      type="text"
                      placeholder={`phoneNumber ${index}`}
                      {...register(`phNumbers.${index}.number`)}
                    />
                    <p className="error">
                      {errors?.phNumbers &&
                        errors?.phNumbers[index]?.number?.message}
                    </p>
                  </div>
                  {index > 0 ? (
                    <button onClick={() => remove(index)}>Remove</button>
                  ) : null}
                </>
              );
            })}
            <button type="add" onClick={() => append({ number: "" })}>
              Add
            </button>
          </div>
          <input type="submit" />
        </form>
      </div>
    </>
  );
};

export default Form1;
